











































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
@Component({})
export default class Indicador extends Vue {
    /* eslint-disable no-console */
    /* Variables globales */
    private fecha = new Date();
    private semana = 0;
    private tdt: any;

    private npsT = 0;
    private npsE = 0;
    private npsG = 0;
    private npsBOSS = 0;
    private npsBOPUS = 0;

    // NUEVO FRONT
    private nps = ['Tienda', "Tienda", 
                   'Grooming', "Grooming", 
                   'Ecommerce', "Ecommerce", 
                   'BOSS', "BOSS", 
                   'BOPUS' ,"BOPUS"];
    private colorNPS = ['color: #925f36', "color: #925f36", 
                        'color: #16a8e1', "color: #16a8e1", 
                        'color: #f49b2c', "color: #f49b2c", 
                        'color: #b17eb4', "color: #b17eb4", 
                        'color: #6f7173', "color: #6f7173"];
    private textNPS = ['color: black', "", 
                       'color: black', "", 
                       'color: black', "", 
                       'color: black', "", 
                       'color: black', ""];
    private colorSimbol = ['black', "", 'black', "", 'black', "", 'black', "", 'black', ""];
    private simbolNPS = ['mdi-minus', "", 'mdi-minus', "", 'mdi-minus', "", 'mdi-minus', "", 'mdi-minus', ""];
    private totalNPS = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    private preNPS = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    private preNPS2 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    private backNPS = ['background-color: #925f36', "", 'background-color: #16a8e1', "", 'background-color: #f49b2c', "", 
                        'background-color: #b17eb4', "", 'background-color: #6f7173', ""];
    private auxTopT: any = [[]];
    private auxTopG: any = [[]];
    private top: any = [];
    private last: any = [];
    private comentarios: any = [];
    private coments = ""
    private translate = "transform: translate(300px);"
    private translateComents = "transform: translate(300px);"
    private index = 0;
    private dataT: any = [];
    private dataG: any = [[]]
    private dataE: any = [[]]
    private dataBOSS: any = [[]]
    private dataBOPUS: any = [[]]
    private data: any = []
    private data2: any = []
    private chartOptions: any = {
                                //  chartArea:{left:100, top:20, width:'200%', height:'200%'},
                                 chartArea:{left:20, top:30, bottom:50, right:90, width:'20%',height:'30%'},
                                 backgroundColor: "#FAFAFA",
                                 legend: { position: "top" },};

    private chartOptions2: any = {title: 'NPS',
                                //  chartArea:{left:100, top:20, width:'200%', height:'200%'},
                                 chartArea:{left:20, top:10, bottom:5, right:5, width:'100%',height:'100%'},
                                 pieHole: 0.4,
                                 backgroundColor: "#FAFAFA"};
    private respuestasTotales: any = []
    private correosTotales: any = []
    private openR: any = []
    private correosAbiertos: any = []
    private correosContestados: any = []
    private tiendaContestados: any = []
    private respuestasTotalesPrev: any = []
    private correosTotalesPrev: any = []
    private correosContestadosPrev: any = []
    private tiendaContestadosPrev: any = []
    private respuestasTotalesDosPrev: any = []
    private correosTotalesDosPrev: any = []
    private correosContestadosDosPrev: any = []
    private tiendaContestadosDosPrev: any = []

    private promotores = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    private neutros = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    private detractores = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    private promotoresBar = ["width: 33%", "width: 33%", 
                             "width: 33%", "width: 33%", 
                             "width: 33%", "width: 33%",
                             "width: 33%", "width: 33%",
                             "width: 33%", "width: 33%"]
    private neutrosBar = ["width: 33%", "width: 33%", 
                          "width: 33%", "width: 33%", 
                          "width: 33%", "width: 33%",
                          "width: 33%", "width: 33%",
                          "width: 33%", "width: 33%"]
    private detractoresBar = ["width: 33%", "width: 33%", 
                              "width: 33%", "width: 33%", 
                              "width: 33%", "width: 33%",
                              "width: 33%", "width: 33%",
                              "width: 33%", "width: 33%"]

    // TERMINA NUEVO FRONT 

    private detractoresT = 0
    private promotoresT = 0
    private neutrosT = 0

    private detractoresE = 0
    private promotoresE = 0
    private neutrosE = 0

    private detractoresG = 0
    private promotoresG = 0
    private neutrosG = 0

    private detractoresBOSS = 0
    private promotoresBOSS = 0
    private neutrosBOSS = 0

    private detractoresBOPUS = 0
    private promotoresBOPUS = 0
    private neutrosBOPUS = 0

    private ISO8601_week_no(dt: any) {
        this.tdt = new Date(dt.valueOf());
        let dayn = (dt.getDay() + 6) % 7;
        this.tdt.setDate(this.tdt.getDate() - dayn + 3);
        let firstThursday = this.tdt.valueOf();
        this.tdt.setMonth(0, 1);
        if (this.tdt.getDay() !== 4) {
            this.tdt.setMonth(0, 1 + ((4 - this.tdt.getDay()) + 7) % 7);
        }
        return 1 + Math.ceil((firstThursday - this.tdt) / 604800000);
    }

    private x = 1500
    private transformX () {
        this.x = this.x - 25
        this.translate = "transform: translate("+this.x+"px)"
        if (this.x === -2000){
            this.x = 1500
        }
             
    }

    private xComents = 17000
    private transformXComents () {
        this.xComents = this.xComents - 25
        // console.log("X: " +this.xComents)
        this.translateComents = "transform: translate("+this.xComents+"px)"
        if (this.xComents === -3000){
            this.xComents = 17000
        }
             
    }

    @Watch('index') indice (nuevo: any){
        this.x = 1500          
       

    }

    private openRate() {
        this.$store.dispatch('GetOpenRate')
        .then ((respuesta) => {
            for (let i of respuesta.ultimaSemana) {
                if (i.origen === 6) {
                    this.correosTotales[0] = i.enviados
                    this.correosAbiertos[0] = i.abiertos
                    if (isNaN(i.openRate)) {
                        this.openR[0] = 0
                    } else { 
                        this.openR[0] = i.openRate
                    }
            
                } else if (i.origen === 4) {
                    this.correosTotales[4] = i.enviados
                    this.correosAbiertos[4] = i.abiertos
                    if (isNaN(i.openRate)) {
                        this.openR[4] = 0
                    } else { 
                        this.openR[4] = i.openRate
                    }
                } else if (i.origen === 3) {
                    this.correosTotales[2] = i.enviados
                    this.correosAbiertos[2] = i.abiertos
                    if (isNaN(i.openRate)) {
                        this.openR[2] = 0
                    } else { 
                        this.openR[2] = i.openRate
                    }
                } else if (i.origen === 2) {
                    this.correosTotales[6] = i.enviados
                    this.correosAbiertos[6] = i.abiertos
                    if (isNaN(i.openRate)) {
                        this.openR[6] = 0
                    } else { 
                        this.openR[6] = i.openRate
                    }
                } else if (i.origen === 1) {
                    this.correosTotales[8] = i.enviados
                    this.correosAbiertos[8] = i.abiertos
                    if (isNaN(i.openRate)) {
                        this.openR[8] = 0
                    } else { 
                        this.openR[8] = i.openRate
                    }
                }
            }
        })  
        .catch ((error) => {

        }); 
    }

    private npsTotales() {
         this.$store.dispatch('GetResueltos')
        .then ((respuesta) => {
            
            for (let i of respuesta) {
                if (i.ID_NPS_ORIGEN === 6) { //NPS TIENDA
                    this.respuestasTotales[0] = i.TOTALES_CONTESTADOS
                    // this.correosTotales[0] = " - "
                    this.correosContestados[0] = i.CORREO_CONTESTADOS
                    this.tiendaContestados[0] = i.TIENDA_CONTESTADOS
                } else if (i.ID_NPS_ORIGEN === 3) { //NPS GROOMING
                    this.respuestasTotales[2] = i.TOTALES_CONTESTADOS
                    // this.correosTotales[2] = " - "
                    this.correosContestados[2] = i.CORREO_CONTESTADOS
                    this.tiendaContestados[2] = i.TIENDA_CONTESTADOS
                } else if (i.ID_NPS_ORIGEN === 4) { //NPS ECOMMERCE
                    this.respuestasTotales[4] = i.TOTALES_CONTESTADOS
                    // this.correosTotales[4] = " - "
                    this.correosContestados[4] = " - "
                    this.tiendaContestados[4] = i.CORREO_CONTESTADOS
                } else if (i.ID_NPS_ORIGEN === 2) { //BOSS
                    this.respuestasTotales[6] = i.TOTALES_CONTESTADOS
                    // this.correosTotales[6] = " - "
                    this.correosContestados[6] = i.CORREO_CONTESTADOS + i.TIENDA_CONTESTADOS
                    this.tiendaContestados[6] = " - "
                } else if (i.ID_NPS_ORIGEN === 1) { //BOPUS
                    this.respuestasTotales[8] = i.TOTALES_CONTESTADOS
                    // this.correosTotales[8] = " - "
                    this.correosContestados[8] = i.CORREO_CONTESTADOS + i.TIENDA_CONTESTADOS
                    this.tiendaContestados[8] = " - "
                }


            }

        })  
        .catch ((error) => {

        }); 
    }

    private npsTotalesSemanaPrevia() {
         this.$store.dispatch('GetResueltosSemanaPrevia')
        .then ((respuesta) => {
            
            for (let i of respuesta) {
                if (i.ID_NPS_ORIGEN === 6) { //NPS TIENDA
                    this.respuestasTotalesPrev[0] = i.TOTALES_CONTESTADOS
                    this.correosTotalesPrev[0] = " - "
                    this.correosContestadosPrev[0] = i.CORREO_CONTESTADOS
                    this.tiendaContestadosPrev[0] = i.TIENDA_CONTESTADOS
                } else if (i.ID_NPS_ORIGEN === 3) { //NPS GROOMING
                    this.respuestasTotalesPrev[2] = i.TOTALES_CONTESTADOS
                    this.correosTotalesPrev[2] = " - "
                    this.correosContestadosPrev[2] = i.CORREO_CONTESTADOS
                    this.tiendaContestadosPrev[2] = i.TIENDA_CONTESTADOS
                } else if (i.ID_NPS_ORIGEN === 4) { //NPS ECOMMERCE
                    this.respuestasTotalesPrev[4] = i.TOTALES_CONTESTADOS
                    this.correosTotalesPrev[4] = " - "
                    this.correosContestadosPrev[4] = " - "
                    this.tiendaContestadosPrev[4] = i.CORREO_CONTESTADOS
                } else if (i.ID_NPS_ORIGEN === 2) { //BOSS
                    this.respuestasTotalesPrev[6] = i.TOTALES_CONTESTADOS
                    this.correosTotalesPrev[6] = " - "
                    this.correosContestadosPrev[6] = i.CORREO_CONTESTADOS + i.TIENDA_CONTESTADOS
                    this.tiendaContestadosPrev[6] = " - "
                } else if (i.ID_NPS_ORIGEN === 1) { //BOPUS
                    this.respuestasTotalesPrev[8] = i.TOTALES_CONTESTADOS
                    this.correosTotalesPrev[8] = " - "
                    this.correosContestadosPrev[8] = i.CORREO_CONTESTADOS + i.TIENDA_CONTESTADOS
                    this.tiendaContestadosPrev[8] = " - "
                }


            }

        })  
        .catch ((error) => {

        }); 
    }

    private npsTotalesSemanaPreviaDos() {
         this.$store.dispatch('GetResueltosDosSemanaPrevia')
        .then ((respuesta) => {
            
            for (let i of respuesta) {
                if (i.ID_NPS_ORIGEN === 6) { //NPS TIENDA
                    this.respuestasTotalesDosPrev[0] = i.TOTALES_CONTESTADOS
                    this.correosTotalesDosPrev[0] = " - "
                    this.correosContestadosDosPrev[0] = i.CORREO_CONTESTADOS
                    this.tiendaContestadosDosPrev[0] = i.TIENDA_CONTESTADOS
                } else if (i.ID_NPS_ORIGEN === 3) { //NPS GROOMING
                    this.respuestasTotalesDosPrev[2] = i.TOTALES_CONTESTADOS
                    this.correosTotalesDosPrev[2] = " - "
                    this.correosContestadosDosPrev[2] = i.CORREO_CONTESTADOS
                    this.tiendaContestadosDosPrev[2] = i.TIENDA_CONTESTADOS
                } else if (i.ID_NPS_ORIGEN === 4) { //NPS ECOMMERCE
                    this.respuestasTotalesDosPrev[4] = i.TOTALES_CONTESTADOS
                    this.correosTotalesDosPrev[4] = " - "
                    this.correosContestadosDosPrev[4] = " - "
                    this.tiendaContestadosDosPrev[4] = i.CORREO_CONTESTADOS
                } else if (i.ID_NPS_ORIGEN === 2) { //BOSS
                    this.respuestasTotalesDosPrev[6] = i.TOTALES_CONTESTADOS
                    this.correosTotalesDosPrev[6] = " - "
                    this.correosContestadosDosPrev[6] = i.CORREO_CONTESTADOS + i.TIENDA_CONTESTADOS
                    this.tiendaContestadosDosPrev[6] = " - "
                } else if (i.ID_NPS_ORIGEN === 1) { //BOPUS
                    this.respuestasTotalesDosPrev[8] = i.TOTALES_CONTESTADOS
                    this.correosTotalesDosPrev[8] = " - "
                    this.correosContestadosDosPrev[8] = i.CORREO_CONTESTADOS + i.TIENDA_CONTESTADOS
                    this.tiendaContestadosDosPrev[8] = " - "
                }


            }

        })  
        .catch ((error) => {

        }); 
    }

    private grafica () {
        

        this.$store.dispatch('GetPromediosByDistrito')
        .then ((respuesta) => {
            // console.log(respuesta);
            this.data = respuesta
        })  
        .catch ((error) => {
        });

        this.$store.dispatch('GetConteoSubconceptos')
        .then ((respuesta) => {
            this.data2 = respuesta
            // console.log("DATA 2");
            // console.log(this.data2);
        
        })  
        .catch ((error) => {

        }); 


    }

    private created() {
        this.calificaciones()
        this.calificacionesByPredict()
        this.semana = this.ISO8601_week_no(this.fecha);
        this.semanaPasada()
        this.semana2Pasada()
        this.calificacionesTiendas()
        this.comentariosNPS()
        this.transformX()
        this.transformXComents()
        
    }

    private mounted() {
        setInterval(this.calificaciones, 60000); //cada 60 segundos
        setInterval(this.calificacionesByPredict, 60000); //cada 60 segundos
        setInterval(this.transformX, 500);
        setInterval(this.transformXComents, 600);
        setInterval(this.comentariosNPS, 600000)
    }

    private calificacionesByPredict() {
        // this.detractoresT = 0
        // this.promotoresT = 0
        // this.neutrosT = 0

        this.detractoresE = 0
        this.promotoresE = 0
        this.neutrosE = 0

        // this.detractoresG = 0
        // this.promotoresG = 0
        // this.neutrosG = 0

        // this.detractoresBOSS = 0
        // this.promotoresBOSS = 0
        // this.neutrosBOSS = 0

        // this.detractoresBOPUS = 0
        // this.promotoresBOPUS = 0
        // this.neutrosBOPUS = 0
        
        this.$store.dispatch('GetResultadosByPredict')
        .then ((respuesta) => {

            for (let i of respuesta) {
                if (i.ORIGEN === 6) { //NPS TIENDA
                    // if (i.ID_NPS_SUBCONCEPTO === 48) {
                    //     this.promotoresT = i.TOTALES_SUBS
                    // } else if (i.ID_NPS_SUBCONCEPTO === 47) {
                    //     this.neutrosT = i.TOTALES_SUBS
                    // } else {
                    //     // @ts-ignore
                    //     this.detractoresT += i.TOTALES_SUBS    
                    //     // console.log(this.detractoresE) 
                    // }

                    // let totales = this.promotoresT + this.neutrosT + this.detractoresT
                    // let aux = (this.promotoresT - this.detractoresT) / (totales) * 100
                    // this.npsT = parseFloat(aux.toFixed(2)); 
                    // this.totalNPS[0] =  parseFloat(aux.toFixed(2));
                    
                    // this.promotoresBar[0] = "width: " +(this.promotoresT/totales)*100 +"%;"
                    // this.neutrosBar[0] = "width: " +(this.neutrosT/totales)*100 +"%;"
                    // this.detractoresBar[0] = "width: " +(this.detractoresT/totales)*100 +"%;"

                    // this.promotoresBar[1] = "width: " +(this.promotoresT/totales)*100 +"%;"
                    // this.neutrosBar[1] = "width: " +(this.neutrosT/totales)*100 +"%;"
                    // this.detractoresBar[1] = "width: " +(this.detractoresT/totales)*100 +"%;"

                    // if (this.totalNPS[0] > this.preNPS[0]) {
                    //     this.simbolNPS[0] = 'mdi-menu-up'
                    //     this.colorSimbol[0] = 'green'
                    //     this.textNPS[0] = 'color: green; '; 
                    // } else if (this.totalNPS[0] < this.preNPS[0]) {
                    //     this.simbolNPS[0] = 'mdi-menu-down'
                    //     this.colorSimbol[0] = 'red' 
                    //     this.textNPS[0] = 'color: red; ';
                    // } else if (this.totalNPS[0] === this.preNPS[0]) {
                    //     this.simbolNPS[0] = 'mdi-minus'
                    //     this.colorSimbol[0] = 'yellow'
                    //     this.textNPS[0] = 'color: yellow; ';
                    // } 
                    // this.promotores[0] = this.promotoresT
                    // this.neutros[0] = this.neutrosT
                    // this.detractores[0] = this.detractoresT
                   
                } else if (i.ORIGEN === 4) { //NPS ECOMMERCE
                    if (i.ID_NPS_SUBCONCEPTO === 48) {
                        this.promotoresE = i.TOTALES_SUBS
                    } else if (i.ID_NPS_SUBCONCEPTO === 47) {
                        this.neutrosE = i.TOTALES_SUBS
                    } else {
                        // @ts-ignore
                        this.detractoresE += i.TOTALES_SUBS    
                        // console.log(this.detractoresE) 
                    }
                    
                    let totales = this.promotoresE + this.neutrosE + this.detractoresE
                    let aux = (this.promotoresE - this.detractoresE) / (totales) * 100
                    this.npsE = parseFloat(aux.toFixed(2)); 
                    this.totalNPS[4] =  parseFloat(aux.toFixed(2));
                    
                    this.promotoresBar[4] = "width: " +(this.promotoresE/totales)*100 +"%;"
                    this.neutrosBar[4] = "width: " +(this.neutrosE/totales)*100 +"%;"
                    this.detractoresBar[4] = "width: " +(this.detractoresE/totales)*100 +"%;"

                    this.promotoresBar[5] = "width: " +(this.promotoresE/totales)*100 +"%;"
                    this.neutrosBar[5] = "width: " +(this.neutrosE/totales)*100 +"%;"
                    this.detractoresBar[5] = "width: " +(this.detractoresE/totales)*100 +"%;"

                    if (this.totalNPS[4] > this.preNPS[4]) {
                        this.simbolNPS[4] = 'mdi-menu-up'
                        this.colorSimbol[4] = 'green'
                        this.textNPS[4] = 'color: green; '; 
                    } else if (this.totalNPS[4] < this.preNPS[4]) {
                        this.simbolNPS[4] = 'mdi-menu-down'
                        this.colorSimbol[4] = 'red' 
                        this.textNPS[4] = 'color: red; ';
                    } else if (this.totalNPS[4] === this.preNPS[4]) {
                        this.simbolNPS[4] = 'mdi-minus'
                        this.colorSimbol[4] = 'yellow'
                        this.textNPS[4] = 'color: yellow; ';
                    } 
                    this.promotores[4] = this.promotoresE
                    this.neutros[4] = this.neutrosE
                    this.detractores[4] = this.detractoresE

                } else if (i.ORIGEN === 3) { //GROOMING
                    // if (i.ID_NPS_SUBCONCEPTO === 48) {
                    //     this.promotoresG = i.TOTALES_SUBS
                    // } else if (i.ID_NPS_SUBCONCEPTO === 47) {
                    //     this.neutrosG = i.TOTALES_SUBS
                    // } else {
                    //     // @ts-ignore
                    //     this.detractoresG += i.TOTALES_SUBS    
                    //     // console.log(this.detractoresE) 
                    // }
                    // let totales = this.promotoresG + this.neutrosG + this.detractoresG
                    // let aux = (this.promotoresG - this.detractoresG) / (totales) * 100
                    // this.npsG = parseFloat(aux.toFixed(2)); 
                    // this.totalNPS[6] =  parseFloat(aux.toFixed(2));
                    
                    // this.promotoresBar[6] = "width: " +(this.promotoresG/totales)*100 +"%;"
                    // this.neutrosBar[6] = "width: " +(this.neutrosG/totales)*100 +"%;"
                    // this.detractoresBar[6] = "width: " +(this.detractoresG/totales)*100 +"%;"

                    // this.promotoresBar[7] = "width: " +(this.promotoresG/totales)*100 +"%;"
                    // this.neutrosBar[7] = "width: " +(this.neutrosG/totales)*100 +"%;"
                    // this.detractoresBar[7] = "width: " +(this.detractoresG/totales)*100 +"%;"

                    // if (this.totalNPS[6] > this.preNPS[6]) {
                    //     this.simbolNPS[6] = 'mdi-menu-up'
                    //     this.colorSimbol[6] = 'green'
                    //     this.textNPS[6] = 'color: green; '; 
                    // } else if (this.totalNPS[6] < this.preNPS[6]) {
                    //     this.simbolNPS[6] = 'mdi-menu-down'
                    //     this.colorSimbol[6] = 'red' 
                    //     this.textNPS[6] = 'color: red; ';
                    // } else if (this.totalNPS[6] === this.preNPS[6]) {
                    //     this.simbolNPS[6] = 'mdi-minus'
                    //     this.colorSimbol[6] = 'yellow'
                    //     this.textNPS[6] = 'color: yellow; ';
                    // } 
                    // this.promotores[6] = this.promotoresG
                    // this.neutros[6] = this.neutrosG
                    // this.detractores[6] = this.detractoresG
                  
                } else if (i.ORIGEN === 2) { //BOSS
                    // if (i.ID_NPS_SUBCONCEPTO === 48) {
                    //     this.promotoresBOSS = i.TOTALES_SUBS
                    // } else if (i.ID_NPS_SUBCONCEPTO === 47) {
                    //     this.neutrosBOSS = i.TOTALES_SUBS
                    // } else {
                    //     // @ts-ignore
                    //     this.detractoresBOSS += i.TOTALES_SUBS    
                    //     // console.log(this.detractoresE) 
                    // }
                    // let totales = this.promotoresBOSS + this.neutrosBOSS + this.detractoresBOSS
                    // let aux = (this.promotoresBOSS - this.detractoresBOSS) / (totales) * 100
                    // this.npsBOSS = parseFloat(aux.toFixed(2)); 
                    // this.totalNPS[2] =  parseFloat(aux.toFixed(2));
                    
                    // this.promotoresBar[2] = "width: " +(this.promotoresBOSS/totales)*100 +"%;"
                    // this.neutrosBar[2] = "width: " +(this.neutrosBOSS/totales)*100 +"%;"
                    // this.detractoresBar[2] = "width: " +(this.detractoresBOSS/totales)*100 +"%;"

                    // this.promotoresBar[3] = "width: " +(this.promotoresBOSS/totales)*100 +"%;"
                    // this.neutrosBar[3] = "width: " +(this.neutrosBOSS/totales)*100 +"%;"
                    // this.detractoresBar[3] = "width: " +(this.detractoresBOSS/totales)*100 +"%;"

                    // if (this.totalNPS[2] > this.preNPS[2]) {
                    //     this.simbolNPS[2] = 'mdi-menu-up'
                    //     this.colorSimbol[2] = 'green'
                    //     this.textNPS[2] = 'color: green; '; 
                    // } else if (this.totalNPS[2] < this.preNPS[2]) {
                    //     this.simbolNPS[2] = 'mdi-menu-down'
                    //     this.colorSimbol[2] = 'red' 
                    //     this.textNPS[2] = 'color: red; ';
                    // } else if (this.totalNPS[2] === this.preNPS[2]) {
                    //     this.simbolNPS[2] = 'mdi-minus'
                    //     this.colorSimbol[2] = 'yellow'
                    //     this.textNPS[2] = 'color: yellow; ';
                    // } 
                    // this.promotores[2] = this.promotoresBOSS
                    // this.neutros[2] = this.neutrosBOSS
                    // this.detractores[2] = this.detractoresBOSS
                   
                
                } else if (i.ORIGEN === 1) { //BOPUS
                    // if (i.ID_NPS_SUBCONCEPTO === 48) {
                    //     this.promotoresBOPUS = i.TOTALES_SUBS
                    // } else if (i.ID_NPS_SUBCONCEPTO === 47) {
                    //     this.neutrosBOSS = i.TOTALES_SUBS
                    // } else {
                    //     // @ts-ignore
                    //     this.detractoresBOSS += i.TOTALES_SUBS    
                    //     // console.log(this.detractoresE) 
                    // }
                    // console.log("Pro: " +this.promotoresBOPUS +" - " +"Neu: " +this.neutrosBOPUS +" - Neg: " +this.detractoresBOPUS);
                    // let totales = this.promotoresBOPUS + this.neutrosBOPUS + this.detractoresBOPUS
                    // let aux = (this.promotoresBOPUS - this.detractoresBOPUS) / (totales) * 100
                    // this.npsBOPUS = parseFloat(aux.toFixed(2)); 
                    // this.totalNPS[8] =  parseFloat(aux.toFixed(2));
                    
                    // this.promotoresBar[8] = "width: " +(this.promotoresBOPUS/totales)*100 +"%;"
                    // this.neutrosBar[8] = "width: " +(this.neutrosBOPUS/totales)*100 +"%;"
                    // this.detractoresBar[8] = "width: " +(this.detractoresBOPUS/totales)*100 +"%;"

                    // this.promotoresBar[9] = "width: " +(this.promotoresBOPUS/totales)*100 +"%;"
                    // this.neutrosBar[9] = "width: " +(this.neutrosBOPUS/totales)*100 +"%;"
                    // this.detractoresBar[9] = "width: " +(this.detractoresBOPUS/totales)*100 +"%;"

                    // if (this.totalNPS[8] > this.preNPS[8]) {
                    //     this.simbolNPS[8] = 'mdi-menu-up'
                    //     this.colorSimbol[8] = 'green'
                    //     this.textNPS[8] = 'color: green; '; 
                    // } else if (this.totalNPS[8] < this.preNPS[8]) {
                    //     this.simbolNPS[8] = 'mdi-menu-down'
                    //     this.colorSimbol[8] = 'red' 
                    //     this.textNPS[8] = 'color: red; ';
                    // } else if (this.totalNPS[8] === this.preNPS[8]) {
                    //     this.simbolNPS[8] = 'mdi-minus'
                    //     this.colorSimbol[8] = 'yellow'
                    //     this.textNPS[8] = 'color: yellow; ';
                    // } 
                    // this.promotores[8] = this.promotoresBOPUS
                    // this.neutros[8] = this.neutrosBOPUS
                    // this.detractores[8] = this.detractoresBOPUS
                
                }
            }

            // this.grafica ()
            // this.npsTotales()
            // this.npsTotalesSemanaPrevia()
            // this.npsTotalesSemanaPreviaDos()
            // this.npsTotales()
            // console.log("E-commerce")
            // console.log("Promotores: " +this.promotoresE)
            // console.log("Neutros: " +this.neutrosE)
            // console.log("Detractores: " +this.detractoresE)
        })  
        .catch ((error) => {

        }); 
    }

    private calificaciones() {
        this.$store.dispatch('GetResultadosNPS')
        .then ((respuesta) => {
            this.detractoresT = 0
            this.promotoresT = 0
            this.neutrosT = 0
            // this.detractoresE = 0
            // this.promotoresE = 0
            // this.neutrosE = 0
            this.detractoresG = 0
            this.promotoresG = 0
            this.neutrosG = 0
            this.detractoresBOSS = 0
            this.promotoresBOSS = 0
            this.neutrosBOSS = 0
            this.detractoresBOPUS = 0
            this.promotoresBOPUS = 0
            this.neutrosBOPUS = 0
         

            for (let i of respuesta) {

                if (i.ID_NPS_ORIGEN === 6) { //NPS TIENDA

                    if (i.PUNTAJE > 8) {
                        this.promotoresT += 1
                    } else if (i.PUNTAJE >= 7 && i.PUNTAJE < 9) {
                        this.neutrosT += 1
                    } else if (i.PUNTAJE < 7) {
                        this.detractoresT += 1
                    } 
                
                    let totales = this.promotoresT + this.neutrosT + this.detractoresT
                    let aux = (this.promotoresT - this.detractoresT) / (totales) * 100
                    this.npsT = parseFloat(aux.toFixed(2));
                    this.totalNPS[0] =  parseFloat(aux.toFixed(2)); 

                    this.promotoresBar[0] = "width: " +(this.promotoresT/totales)*100 +"%;"
                    this.neutrosBar[0] = "width: " +(this.neutrosT/totales)*100 +"%;"
                    this.detractoresBar[0] = "width: " +(this.detractoresT/totales)*100 +"%;"

                    this.promotoresBar[1] = "width: " +(this.promotoresT/totales)*100 +"%;"
                    this.neutrosBar[1] = "width: " +(this.neutrosT/totales)*100 +"%;"
                    this.detractoresBar[1] = "width: " +(this.detractoresT/totales)*100 +"%;"

                    if (this.totalNPS[0] > this.preNPS[0]) {
                        this.simbolNPS[0] = 'mdi-menu-up'
                        this.colorSimbol[0] = 'green'
                        this.textNPS[0] = 'color: green; ';
                    } else if (this.totalNPS[0] < this.preNPS[0]) {
                        this.simbolNPS[0] = 'mdi-menu-down'
                        this.colorSimbol[0] = 'red' 
                        this.textNPS[0] = 'color: red; ';
                    } else if (this.totalNPS[0] === this.preNPS[0]) {
                        this.simbolNPS[0] = 'mdi-minus'
                        this.colorSimbol[0] = 'yellow'
                        this.textNPS[0] = 'color: yellow; ';
                    } 
                    this.promotores[0] = this.promotoresT
                    this.neutros[0] = this.neutrosT
                    this.detractores[0] = this.detractoresT

                } else if (i.ID_NPS_ORIGEN === 4) { //NPS ECOMMERCE

                    // if (i.PUNTAJE > 8) {
                    //     this.promotoresE += 1
                    // } else if (i.PUNTAJE >= 7 && i.PUNTAJE < 9) { 
                    //     this.neutrosE +=1
                    // } else if (i.PUNTAJE < 7) {
                    //     this.detractoresE += 1
                    // }
                    
                    // let totales = this.promotoresE + this.neutrosE + this.detractoresE
                    // let aux = (this.promotoresE - this.detractoresE) / (totales) * 100
                    // this.npsE = parseFloat(aux.toFixed(2)); 
                    // this.totalNPS[2] =  parseFloat(aux.toFixed(2)); 

                    // if (this.totalNPS[2] > this.preNPS[2]) {
                    //     this.simbolNPS[2] = 'mdi-menu-up'
                    //     this.colorSimbol[2] = 'green'
                    //     this.textNPS[2] = 'color: green; '; 
                    // } else if (this.totalNPS[2] < this.preNPS[2]) {
                    //     this.simbolNPS[2] = 'mdi-menu-down'
                    //     this.colorSimbol[2] = 'red' 
                    //     this.textNPS[2] = 'color: red; ';
                    // } else if (this.totalNPS[2] === this.preNPS[2]) {
                    //     this.simbolNPS[2] = 'mdi-minus'
                    //     this.colorSimbol[2] = 'yellow'
                    //     this.textNPS[2] = 'color: yellow; ';
                    // } 

                } else if (i.ID_NPS_ORIGEN === 3) { //GROOMING

                    if (i.PUNTAJE > 8) {
                        this.promotoresG += 1
                    } else if (i.PUNTAJE >= 7 && i.PUNTAJE < 9) { 
                        this.neutrosG +=1
                    } else if (i.PUNTAJE < 7) {
                        this.detractoresG += 1
                    }
                    
                    let totales = this.promotoresG + this.neutrosG + this.detractoresG
                    let aux = (this.promotoresG - this.detractoresG) / (totales) * 100
                    this.npsG = parseFloat(aux.toFixed(2)); 
                    this.totalNPS[2] =  parseFloat(aux.toFixed(2)); 

                    this.promotoresBar[2] = "width: " +(this.promotoresG/totales)*100 +"%;"
                    this.neutrosBar[2] = "width: " +(this.neutrosG/totales)*100 +"%;"
                    this.detractoresBar[2] = "width: " +(this.detractoresG/totales)*100 +"%;"

                    this.promotoresBar[3] = "width: " +(this.promotoresG/totales)*100 +"%;"
                    this.neutrosBar[3] = "width: " +(this.neutrosG/totales)*100 +"%;"
                    this.detractoresBar[3] = "width: " +(this.detractoresG/totales)*100 +"%;"

                    if (this.totalNPS[2] > this.preNPS[2]) {
                        this.simbolNPS[2] = 'mdi-menu-up'
                        this.colorSimbol[2] = 'green'
                        this.textNPS[2] = 'color: green; ';
                    } else if (this.totalNPS[2] < this.preNPS[2]) {
                        this.simbolNPS[2] = 'mdi-menu-down'
                        this.colorSimbol[2]  = 'red' 
                        this.textNPS[2] = 'color: red; ';
                    } else if (this.totalNPS[2] === this.preNPS[2]) {
                        this.simbolNPS[2] = 'mdi-minus'
                        this.colorSimbol[2]  = 'yellow' 
                        this.textNPS[2] = 'color: yellow; ';
                    }
                    this.promotores[2] = this.promotoresG
                    this.neutros[2] = this.neutrosG
                    this.detractores[2] = this.detractoresG
                
                } else if (i.ID_NPS_ORIGEN === 2) { //BOSS
                    
                    if (i.PUNTAJE > 8) {
                        this.promotoresBOSS += 1
                    } else if (i.PUNTAJE >= 7 && i.PUNTAJE < 9) { 
                        this.neutrosBOSS +=1
                    } else if (i.PUNTAJE < 7) {
                        this.detractoresBOSS += 1
                    }
                    
                    let totales = this.promotoresBOSS + this.neutrosBOSS + this.detractoresBOSS
                    let aux = (this.promotoresBOSS - this.detractoresBOSS) / (totales) * 100
                    this.npsBOSS = parseFloat(aux.toFixed(2));
                    this.totalNPS[6] =  parseFloat(aux.toFixed(2)); 

                    this.promotoresBar[6] = "width: " +(this.promotoresBOSS/totales)*100 +"%;"
                    this.neutrosBar[6] = "width: " +(this.neutrosBOSS/totales)*100 +"%;"
                    this.detractoresBar[6] = "width: " +(this.detractoresBOSS/totales)*100 +"%;"

                    this.promotoresBar[7] = "width: " +(this.promotoresBOSS/totales)*100 +"%;"
                    this.neutrosBar[7] = "width: " +(this.neutrosBOSS/totales)*100 +"%;"
                    this.detractoresBar[7] = "width: " +(this.detractoresBOSS/totales)*100 +"%;"

                    if (this.totalNPS[6] > this.preNPS[6]) {
                        this.simbolNPS[6] = 'mdi-menu-up'
                        this.colorSimbol[6] = 'green' 
                        this.textNPS[6] = 'color: green; ';
                    } else if (this.totalNPS[6] < this.preNPS[6]) {
                        this.simbolNPS[6] = 'mdi-menu-down'
                        this.colorSimbol[6] = 'red' 
                        this.textNPS[6] = 'color: red; ';
                    } else if (this.totalNPS[6] === this.preNPS[6]) {
                        this.simbolNPS[6] = 'mdi-minus'
                        this.colorSimbol[6] = 'yellow' 
                        this.textNPS[6] = 'color: yellow; ';                    
                    }
                    this.promotores[6] = this.promotoresBOSS
                    this.neutros[6] = this.neutrosBOSS
                    this.detractores[6] = this.detractoresBOSS
                
                } else if (i.ID_NPS_ORIGEN === 1) { //BOPUS
                    
                    if (i.PUNTAJE > 8) {
                        this.promotoresBOPUS += 1
                    } else if (i.PUNTAJE >= 7 && i.PUNTAJE < 9) { 
                        this.neutrosBOPUS +=1
                    } else if (i.PUNTAJE < 7) {
                        this.detractoresBOPUS += 1
                    }
                    
                    let totales = this.promotoresBOPUS + this.neutrosBOPUS + this.detractoresBOPUS
                    let aux = (this.promotoresBOPUS - this.detractoresBOPUS) / (totales) * 100
                    this.npsBOPUS = parseFloat(aux.toFixed(2)); 
                    this.totalNPS[8] =  parseFloat(aux.toFixed(2)); 

                    this.promotoresBar[8] = "width: " +(this.promotoresBOPUS/totales)*100 +"%;"
                    this.neutrosBar[8] = "width: " +(this.neutrosBOPUS/totales)*100 +"%;"
                    this.detractoresBar[8] = "width: " +(this.detractoresBOPUS/totales)*100 +"%;"

                    this.promotoresBar[9] = "width: " +(this.promotoresBOPUS/totales)*100 +"%;"
                    this.neutrosBar[9] = "width: " +(this.neutrosBOPUS/totales)*100 +"%;"
                    this.detractoresBar[9] = "width: " +(this.detractoresBOPUS/totales)*100 +"%;"

                    if (this.totalNPS[8] > this.preNPS[8]) {
                        this.simbolNPS[8] = 'mdi-menu-up'
                        this.colorSimbol[8] = 'green'
                        this.textNPS[8] = 'color: green; '; 
                    } else if (this.totalNPS[8] < this.preNPS[8]) {
                        this.simbolNPS[8] = 'mdi-menu-down'
                        this.colorSimbol[8] = 'red'
                        this.textNPS[8] = 'color: red; '; 
                    } else if (this.totalNPS[8] === this.preNPS[8]) {
                        this.simbolNPS[8] = 'mdi-minus'
                        this.colorSimbol[8] = 'yellow'
                        this.textNPS[8] = 'color: yellow; '; 
                    }
                    this.promotores[8] = this.promotoresBOPUS
                    this.neutros[8] = this.neutrosBOPUS
                    this.detractores[8] = this.detractoresBOPUS
                
                }
            }
            this.grafica()
            this.openRate()
            this.npsTotales()
            this.npsTotalesSemanaPrevia()
            this.npsTotalesSemanaPreviaDos()
            // console.log("TIENDA:    P => " +this.promotoresT +" - N => " +this.neutrosT +" - D => " +this.detractoresT)
            // console.log("GROOMING:  P => " +this.promotoresG +" - N => " +this.neutrosG +" - D => " +this.detractoresG)
            //console.log("ECOMMERCE: P => " +this.promotoresE +" - N => " +this.neutrosE +" - D => " +this.detractoresE)
            // console.log("BOSS:      P => " +this.promotoresBOSS +" - N => " +this.neutrosBOSS +" - D => " +this.detractoresBOSS)
            // console.log("BOPUS:     P => " +this.promotoresBOPUS +" - N => " +this.neutrosBOPUS +" - D => " +this.detractoresBOPUS)

        })  
        .catch ((error) => {

        }); 


        let hoy = new Date();
        let dia = hoy.getDay()
        let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        let hora = hoy.getHours()
        let minutos = hoy.getMinutes()
        let i = 0
        if (days[dia] === "Sunday" && hora === 21 && minutos === 0) {
            if (i === 0) {
                this.insertarPromedios()
                i += 1
            }
        }
        
    }

    private insertarPromedios() {
        //AQUI VA OBTENER EN LA BD LA SEMANA ANTERIOR Y GUARDAR DE LA SEMANA ACTUAL
        let data = {
            tienda: this.npsT,
            ecommerce: this.npsE,
            grooming: this.npsG,
            boss: this.npsBOSS,
            bopus: this.npsBOPUS
        };
        this.$store.dispatch('GuardaPromedios', data)
        .then ((respuesta) => {
        })  
        .catch ((error) => {

        });
    }

    private semanaPasada() {
        this.$store.dispatch('GetPromediosNPS')
        .then ((respuesta) => {
            for (let i of respuesta) {
                if (i.IDNPS === 1) { //Grooming parseFloat(aux.toFixed(2))
                    this.preNPS[2] = parseFloat(i.PORCENTAJE.toFixed(2))
                } else if (i.IDNPS === 2) { //Tienda
                    this.preNPS[0] = parseFloat(i.PORCENTAJE.toFixed(2))
                } else if (i.IDNPS === 3) { //BOSS
                    this.preNPS[6] = parseFloat(i.PORCENTAJE.toFixed(2))
                } else if (i.IDNPS === 4) { //BOPUS
                    this.preNPS[8] = parseFloat(i.PORCENTAJE.toFixed(2))
                } else if (i.IDNPS === 5) { //ECOMMERCE
                    this.preNPS[4] = parseFloat(i.PORCENTAJE.toFixed(2))
                }
            }
        })  
        .catch ((error) => {

        });  
    }

    private semana2Pasada() {
        this.$store.dispatch('GetPromedios2NPS')
        .then ((respuesta) => {
            for (let i of respuesta) {
                if (i.IDNPS === 1) { //Grooming parseFloat(aux.toFixed(2))
                    this.preNPS2[2] = parseFloat(i.PORCENTAJE.toFixed(2))
                } else if (i.IDNPS === 2) { //Tienda
                    this.preNPS2[0] = parseFloat(i.PORCENTAJE.toFixed(2))
                } else if (i.IDNPS === 3) { //BOSS
                    this.preNPS2[6] = parseFloat(i.PORCENTAJE.toFixed(2))
                } else if (i.IDNPS === 4) { //BOPUS
                    this.preNPS2[8] = parseFloat(i.PORCENTAJE.toFixed(2))
                } else if (i.IDNPS === 5) { //ECOMMERCE
                    this.preNPS2[4] = parseFloat(i.PORCENTAJE.toFixed(2))
                }
            }
        })  
        .catch ((error) => {

        });  
    }

    private async calificacionesTiendas() {
        this.$store.dispatch('GetPromediosByTienda')
        .then (async (respuesta) => {

            for (let i of respuesta) {
                if (i.ID_NPS_ORIGEN === 6) {
                    if (i.TIENDA.length > 0) {
                        this.auxTopT.push(new Promise((resolve: any, reject: any) => {
                            this.$store.dispatch('GetTienda', i.TIENDA)
                            .then ((response) => {
                                let promedio = parseFloat(((i.PROMOTORES - i.DETRACTORES) / (i.PROMOTORES + i.NEUTROS + i.DETRACTORES) * 100).toFixed(2))
                                if (isNaN(promedio)) {
                                    resolve([null, null])
                                } else {
                                    resolve([promedio, "% - " +response +" | "])
                                }
                            })  
                            .catch ((error) => {

                            });
                        })) 
                        
                    }
                } else if (i.ID_NPS_ORIGEN === 3) {
                    if (i.TIENDA.length > 0) {
                        this.auxTopG.push(new Promise((resolve: any, reject: any) => {
                            this.$store.dispatch('GetTienda', i.TIENDA)
                            .then ((response) => {
                                let promedio = parseFloat(((i.PROMOTORES - i.DETRACTORES) / (i.PROMOTORES + i.NEUTROS + i.DETRACTORES) * 100).toFixed(2))
                                if (isNaN(promedio)) {
                                    resolve([null, null])
                                } else {
                                    resolve([promedio, "% - " +response +" | "])
                                }
                            })  
                            .catch ((error) => {

                            });
                        })) 
                    }
                }
            }

            let auxTienda = await Promise.all(this.auxTopT)
            let auxGrooming = await Promise.all(this.auxTopG)
      
            auxTienda = auxTienda.sort(this.compareSecondColumn)
            auxGrooming = auxGrooming.sort(this.compareSecondColumn)

            let topT = auxTienda.slice(0,10).join("  ").replace(/,/g, "")
            let topG = auxGrooming.slice(0,10).join("  ").replace(/,/g, "")

            //console.log(topG)
            
            this.top.push(topT)
            this.top.push("")
            this.top.push(topG)
            this.top.push("")
            this.top.push("")
            this.top.push("")
            this.top.push("")
            this.top.push("")
            this.top.push("")
            this.top.push("")

          
            let lastT = auxTienda.slice(-11).join("  ").replace(/,/g, "")
            let lastG = auxGrooming.slice(-11).join("  ").replace(/,/g, "")

            //console.log(lastG)

            this.last.push(lastT)
            this.last.push("")     
            this.last.push(lastG)
            this.last.push("")
            this.last.push("")
            this.last.push("")
            this.last.push("")
            this.last.push("")
            this.last.push("")
            this.last.push("")

    
           
           
        })  
        .catch ((error) => {

        }); 
    }

    private comentariosNPS() {
        let auxT: any = []
        let auxG: any = []
        let auxE: any = []
        let auxBOSS: any = []
        let auxBOPUS: any = []

        this.$store.dispatch('GetComentariosNPS')
        .then (async (respuesta) => {
            for (let i of respuesta) {
                if (i.ORIGEN === 6) {
                    auxT.push(i.COMENTARIO)
                } else if (i.ORIGEN === 4) {
                    auxE.push(i.COMENTARIO)
                } else if (i.ORIGEN === 3) {
                    auxG.push(i.COMENTARIO)
                } else if (i.ORIGEN === 2) {
                    auxBOSS.push(i.COMENTARIO)
                } else if (i.ORIGEN === 1) {
                    auxBOPUS.push(i.COMENTARIO)
                }
            }
           

            // console.log("Aux: " +auxT.join(" | ").replace(/\n/g, ""))
            // console.log("Aux: " +auxE.join(" | ").replace(/\n/g, ""))
            // console.log("Aux: " +auxG.join(" | ").replace(/\n/g, ""))
            // console.log("Aux: " +auxBOSS.join(" | ").replace(/\n/g, ""))
            // console.log("Aux: " +auxBOPUS.join(" | ").replace(/\n/g, ""))

            this.comentarios = [auxT.join(" | ").replace(/\n/g, ""), auxT.join(" | ").replace(/\n/g, ""), auxG.join(" | ").replace(/\n/g, ""), auxG.join(" | ").replace(/\n/g, ""), auxE.join(" | ").replace(/\n/g, ""), auxE.join(" | ").replace(/\n/g, ""), auxBOSS.join(" | ").replace(/\n/g, ""), auxBOSS.join(" | ").replace(/\n/g, ""), auxBOPUS.join(" | ").replace(/\n/g, ""), auxBOPUS.join(" | ").replace(/\n/g, "")]
            console.log("Comentarios: " +this.comentarios)

        })  
        .catch ((error) => {

        }); 
    }

    private compareSecondColumn(paramA: any, paramB: any) {
        if (paramA[0] === paramB[0]) {
            return 0;
        }
        else {
            return (paramA[0] > paramB[0]) ? -1 : 1;
        }
    }

}
